import * as React from 'react';
import gql from 'graphql-tag';
import AuthorizedQuery from './AuthorizedQuery';

const FIELDS_FRAGMENT = `fields {
  id
  name
  area
  currentCrop
  geometry {
    coordinates
    type
  }
  status {
    ready
    progress
  }
}`;

const SCENES_FRAGMENT = `scenes {
  id
  sceneId
  sceneSource
  retrievalKey
  capturedOn
}`;

const USERS_FRAGMENT = `users {
  id
  firstName
  lastName
  email
  role
}`;

const FARM_QUERY = (props: Props) =>
  gql(`
  query Farm($id: ID!) {
    farm(id: $id) {
      id
      name
      myRole
      geometry {
        coordinates
        type
      }
      ${props.includeScenes ? SCENES_FRAGMENT : ''}
      ${props.includeFields ? FIELDS_FRAGMENT : ''}
      ${props.includeUsers ? USERS_FRAGMENT : ''}
    }
  }
`);

interface Props {
  farmId?: string;
  includeScenes?: boolean;
  includeFields?: boolean;
  includeUsers?: boolean;
  children: (
    farm: Farm | null,
    loading: boolean,
    refetch?: () => void
  ) => React.ReactNode;
}

const FarmProvider: React.StatelessComponent<Props> = (props: Props) => (
  <AuthorizedQuery
    query={FARM_QUERY(props)}
    variables={{ id: props.farmId }}
    fetchPolicy="network-only"
  >
    {({ data, loading, refetch }) => {
      return props.children(data && data.farm, loading, refetch);
    }}
  </AuthorizedQuery>
);

export default FarmProvider;



// WEBPACK FOOTER //
// ./src/providers/FarmProvider.tsx